import { configureStore } from "@reduxjs/toolkit";
import { spreadsheetsReducer } from "./slices/spreadsheets.slice";
import { IRootState } from "./types";
import { assignmentsReducer } from "./slices/assignments.slice";

const reducer: IRootState = {
  spreadsheets: spreadsheetsReducer,
  assignments: assignmentsReducer,
};

const store = configureStore({
  reducer: reducer,
});

export default store;
